import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl, FormattedMessage, defineMessages } from "react-intl";
import { useHistory, useParams } from "react-router-dom";
import {
    fetchWorkorder,
    taskSendToBell,
    fetchWorkorderPONum,
    getCancelWorkorderReason,
    fetchVendorManager,
    clearWorkOrderData,
    clearAssignmentsInfo,
    requestToTabChange,
    requestToAddFollowup,
    taskComplete,
} from "../../redux/task/taskActions";
import { requestFollowUpDueDate } from "../../redux/followUps/followUpsActions";
import { fetchBillingComments, clearComments } from "../../redux/billing/billingActions";
import { setFilesToUpload, clearAttachments } from "../../redux/attachments/attachmentsActions";
import { Button, Tab, Tabs, Typography } from "@material-ui/core";
import { makeStyles, styled } from "@material-ui/core/styles";
import { ChevronLeft } from "@material-ui/icons";
import CostInformation from "./costInformation";
import RelatedWork from "./relatedWork/RelatedWork";
import WorkOrderInformation from "./workOrderInformation";
import { MainHeader } from "../header/mainHeader";
import Settings from "../header/headerActions/settings";
import Profile from "../header/headerActions/profile";
import WorkOrderList from "../header/headerActions/workOrderList";
import PrintIcon from "../common/icons/printIcon";
import { isRequiredSentToBell, isActionsRequired, isActionRequired } from "../../globals/workOrderStatus";
import { useLocalizedName } from "../../globals/langHelpers";
import Modal from "../common/modal/modal";
import Actions from "../header/headerActions/actions";
import IncompleteJob from "./incompleteJob";
import CompletionCode from "./completionCodePopup";
import AdditionalActions from "../header/headerActions/additionalActions";
import AssignTask from "../assignTask/assignTask";
import ShowOverlapsModal from "../assignTask/showOverlapsModal";

const messages = defineMessages({
    bellModalTitle: {
        id: "admin.work-order-details.sent-to-bell-dialog.title",
        defaultMessage: "Send To Bell",
        description: "sent to bell dialog title",
    },
    workOrderInfoTabCaption: {
        id: "admin.work-order-details.wo-info-tab.caption",
        defaultMessage: "Work order information",
        description: "Work order information tab",
    },
    costInfoTabCaption: {
        id: "admin.work-order-details.cost-info-tab.caption",
        defaultMessage: "Cost information",
        description: "Cost information tab",
    },
    locateInfoTabCaption: {
        id: "admin.work-order-details.related-work-tab.caption",
        defaultMessage: "Related work",
        description: "Related work tab",
    },
    sending: {
        id: "admin.work-order-details.sending.message",
        defaultMessage: "Sending…",
        description: "Sending to bell message",
    },
});

export const useWorkOrderStyles = makeStyles((theme) => ({
    fiedlStyle: {
        [theme.breakpoints.down("xs")]: {
            whiteSpace: "initial !important",
        },
    },
    header: {
        border: "none",
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        boxShadow: "0px 1px 10px 0px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 4px 0px rgba(0, 0, 0, 0.14)",
        paddingTop: "24px",
        paddingLeft: "200px",

        "@media print": {
            paddingLeft: "10px",
        },
    },

    notPrinted: {
        "@media print": {
            display: "none",
        },
    },
    tabContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingRight: "22px",
    },
    tab: {
        border: "none",
        width: "100%",
        paddingLeft: "200px",
        paddingRight: "200px",

        "@media print": {
            paddingLeft: "10px",
            paddingRight: "10px",
            display: "block !important",
            pageBreakAfter: "always",
        },
    },
    workOrderBack: {
        color: "var(--blue-bell)",
        fontFamily: "Arial",
        fontSize: "16px",
        padding: "22px 48px",
        position: "absolute",
        "&:hover": {
            cursor: "pointer",
        },
    },
    workOrderTitle: {
        color: "var(--text-dark)",
        fontFamily: "BellSlimBlack",
        fontWeight: "900",
        lineHeight: "38px",
        fontSize: "28px",
        letterSpacing: "-1%",
    },
    workOrderStatus: {
        color: "#111111",
        fontFamily: "Arial",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "24px",
        display: "inline",
    },
    row: {
        marginBottom: "32px",
    },
    print: {
        float: "right",

        fontFamily: "Arial",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "24px",

        padding: "7px 14px",
    },

    cardHeader: {
        fontFamily: "Arial",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "24px",
        color: "var(--text-medium)",
        paddingTop: "35px",
        "&::after": {
            content: '"',
            border: "10px solid green",
            background: "#f00",
            position: "absolute",
            width: "100%",
            top: "50%",
            marginTop: "-2px",
            marginLeft: "10px",
        },
    },

    informationIcon: {
        width: 14,
        height: 14,
        color: "var(--blue-bell)",
    },

    tooltip: {
        backgroundColor: "var(--blue-bell)",
    },
    workOrderAdditionalActions: {
        color: "#555555",
        fontFamily: "Arial",
        fontSize: "14px",
        lineHeight: "24px",
    },
    alert: {
        width: "100%",
        border: "1px solid #FA9E00 ",
        color: "#111111",
        lineHeight: "16px",
        borderRadius: "4px 0px 0px 4px",
        marginTop: "4px",
    },
    alertMessage: {
        margin: "4px 0px",
        fontSize: "14px",
        lineHeight: "16px",
        padding: "4px 12px",
    },
    spinner: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        height: "50vh",
    },
    loader: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        height: "25vh",
    },
    unAssingedStatus: {
        cursor: "pointer",
        fontWeight: "bold",
        padding: "16px 0px 0px 15px",
        fontSize: "18px",
        fontFamily: "Arial",
    },
    footerStyle: {
        width: "100%",
        height: "50px",
        background: "#C2CEDF",
        position: "relative",
        bottom: 0,
        zIndex: 0,
        left: 0,
        top: "-58px",
        "border-bottom-right-radius": "4px",
        "border-bottom-left-radius": "4px",
    },
    skuContainer: {
        overflowX: "auto",
        margin: "0.8rem 0p",
        padding: "0.8rem 0.8rem 0 0.8rem",
        background: "#ffffff",
        borderRadius: "4px",
        fontFamily: "Arial",
        border: "1px solid rgba(0,0,0,.125)",
    },
}));
const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    const classes = useWorkOrderStyles();

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            className={classes.tab}
            {...other}>
            <div
                style={{
                    paddingTop: "12px",
                }}>
                {children}
            </div>
        </div>
    );
};

export const CardTitle = styled(Typography)({
    color: "var(--text-dark)",

    fontFamily: "Arial",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "18px",

    marginBottom: "24px",
    display: "inline-block",
});

export const Caption = styled(Typography)({
    color: "var(--text-medium)",

    fontFamily: "Arial",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "16.1px",

    marginBottom: "4px",
    display: "inline-block",
});

export const Value = styled(Typography)({
    color: "var(--text-dark)",

    fontFamily: "Arial",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "16.1px",
});

export const WinterPricingValue = styled(Typography)({
    color: "#0075FF",

    fontFamily: "Arial",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "16.1px",
});

export const ValueMultiLined = styled(Typography)({
    color: "var(--text-dark)",

    fontFamily: "Arial",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "16.1px",
    whiteSpace: "initial",
});

const WorkOrderDetails = () => {
    const { workOrderNumber } = useParams();
    const dispatch = useDispatch();
    const workOrderData = useSelector((state) => state.tasks.workorderData);
    const purchaseOrderNumber = useSelector((state) => state.tasks.purchaseOrderNumber);
    const requestTabValue = useSelector((state) => state.tasks.requestTabValue);
    const userInfo = useSelector((state) => state.login.userInfo);
    const disbaleButton = useSelector((state) => state.tasks.disbaleButton);
    const [selectedTab, setSelectedTab] = React.useState(requestTabValue);
    const [isLoading, setLoading] = React.useState(false);
    const [show, isShow] = React.useState(false);
    const [triggerPopup, setTriggerPopup] = useState(false);
    const [showInCompleteModal, setShowInCompleteModal] = React.useState(false);
    const [showCompletionModal, setShowCompletionModal] = React.useState(false);
    const [showAssignmentModal, setShowAssignmentModal] = React.useState(false);
    const classes = useWorkOrderStyles();
    const history = useHistory();
    const intl = useIntl();
    const { getLocalizedName } = useLocalizedName();

    useEffect(() => {
        if (workOrderData?.workorderData?.workActivity)
            dispatch(
                fetchVendorManager(
                    workOrderData?.workorderData?.zone ? workOrderData?.workorderData?.zone?.replace("C_", "") : null,
                    workOrderData?.workorderData?.workActivityId ? workOrderData?.workorderData?.workActivityId : null,
                ),
            );
    }, [workOrderData]);

    useEffect(() => {
        return () => {
            if (history.action === "POP") {
                dispatch(clearWorkOrderData());
                dispatch(clearAttachments());
                dispatch(setFilesToUpload([]));
                dispatch(clearAssignmentsInfo());
                dispatch(clearComments());
                dispatch(requestToTabChange(0));
                dispatch(requestToAddFollowup(false));
            }
        };
    }, [history]);

    useEffect(() => {
        dispatch(fetchWorkorder(workOrderNumber, true));
        dispatch(fetchWorkorderPONum(workOrderNumber));
        dispatch(getCancelWorkorderReason(workOrderNumber));
        dispatch(fetchBillingComments(workOrderNumber));
        // Set the document title to the work order number so that
        // we can print to pdf with the work order number as the default
        // filename
        document.title = workOrderNumber;
    }, [workOrderNumber]);

    useEffect(() => {
        return function cleanup() {
            // Clear any files we were going to upload but didn't, so that
            // if we navigate to another work order, they won't appear there
            dispatch(setFilesToUpload([]));
        };
    });

    useEffect(() => {
        setSelectedTab(requestTabValue);
    }, [requestTabValue]);

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
        dispatch(requestToTabChange(newValue));
        dispatch(requestToAddFollowup(false));
        dispatch(requestFollowUpDueDate(workOrderNumber));
    };

    const enabledCostInformation = true;

    const sendToBell = () => {
        dispatch(taskSendToBell(workOrderNumber, true));
        setLoading(true);
        isShow(false);
    };

    const isSendToBellEnabled = () => {
        if (workOrderData?.workorderData?.reasonCodeId === 1) return true;

        if (workOrderData?.relatedIdInformation?.tasks?.skuList?.results?.length) return true;

        return false;
    };

    const isStatusClosed = () => {
        if (
            workOrderData?.workorderData?.status &&
            (workOrderData?.workorderData?.status?.id === 12 || workOrderData?.workorderData?.status?.id === 15)
        )
            return true;
        return false;
    };

    const print = () => {
        window.print();
    };
    const goBackFunction = () => {
        history.goBack();
        dispatch(clearWorkOrderData());
        dispatch(clearAttachments());
        dispatch(setFilesToUpload([]));
        dispatch(clearAssignmentsInfo());
        dispatch(clearComments());
    };
    const completeTask = (val, completionDate) => {
        dispatch(
            taskComplete({
                workOrderNumber: workOrderData?.workorderData?.workOrderNumber,
                userName: userInfo?.preferred_username,
                completionCode: +val,
                completionDate: completionDate,
            }),
        );
    };
    const handleUnassignPopup = () => {
        setShowAssignmentModal(true);
    };
    return (
        <div>
            <Modal
                show={show}
                title={intl.formatMessage(messages.bellModalTitle)}
                onClose={() => isShow(false)}
                buttons={[
                    <Button key="0" onClick={sendToBell}>
                        <FormattedMessage
                            id="admin.work-order-details.sent-to-bell-dialog.send-to-bell-button"
                            defaultMessage="Yes"
                            description="Yes button caption"
                        />
                    </Button>,
                ]}>
                <FormattedMessage
                    id="admin.work-order-details.sent-to-bell-dialog.confirmation-message"
                    defaultMessage="Are you sure you want to submit WorkOrder?"
                    description="Are you sure you want to submit WorkOrder?"
                />
            </Modal>
            {showInCompleteModal && (
                <IncompleteJob
                    showInCompleteModal
                    dueDate={workOrderData?.workorderData?.originalDueDate}
                    workOrderNumber={workOrderData?.workorderData?.workOrderNumber}
                    setShowInCompleteModal={setShowInCompleteModal}
                />
            )}
            {showCompletionModal && (
                <CompletionCode
                    showCompletionModal
                    dueDate={workOrderData?.workorderData?.originalDueDate}
                    workOrderNumber={workOrderData?.workorderData?.workOrderNumber}
                    setShowCompletionModal={setShowCompletionModal}
                    onCompletionCallback={completeTask}
                    workorderData={workOrderData?.workorderData}
                    cmisAdmin
                />
            )}
            {showAssignmentModal && (
                <AssignTask workOrder={workOrderData?.workorderData} show={showAssignmentModal} close={() => setShowAssignmentModal(false)} />
            )}
            <ShowOverlapsModal id="show-overlap-modal" />
            <MainHeader subtitle="CMIS" actions={[<WorkOrderList />, <Settings />, <Profile />]} />
            <div className={`${classes.workOrderBack} ${classes.notPrinted}`} onClick={goBackFunction}>
                <ChevronLeft fontSize="small" />

                <FormattedMessage id="admin.work-order-details.back" defaultMessage="Back" description="Admin work order back button" />
            </div>
            <div className={classes.header}>
                <div className={classes.workOrderTitle}>
                    <FormattedMessage
                        id="admin.work-order-details.work-order-number-label"
                        defaultMessage="Work order #{workOrderNumber}"
                        description="Admin work order number label"
                        values={{
                            workOrderNumber: workOrderNumber,
                        }}
                    />
                </div>
                <div>
                    {isActionsRequired(workOrderData?.workorderData?.status) ? (
                        <Actions
                            isAdmin={true}
                            onComplete={() => setShowCompletionModal(true)}
                            onInComplete={() => setShowInCompleteModal(true)}
                            jobActions={false}
                        />
                    ) : isActionRequired(workOrderData?.workorderData?.status) ? (
                        <Button onClick={handleUnassignPopup} className={classes.unAssingedStatus}>
                            {getLocalizedName({ object: workOrderData?.workorderData?.status })}
                        </Button>
                    ) : (
                        <div>{getLocalizedName({ object: workOrderData?.workorderData?.status })}</div>
                    )}
                </div>
                {isRequiredSentToBell(workOrderData?.workorderData?.status) ? (
                    isLoading ? (
                        intl.formatMessage(messages.sending)
                    ) : (
                        <Button onClick={() => isShow(true)} className={classes.notPrinted} disabled={!isSendToBellEnabled() || disbaleButton}>
                            <FormattedMessage
                                id="admin.work-order-details.send-to-bell"
                                defaultMessage="Send to Bell"
                                description="Admin work order send to Bell button"
                            />
                        </Button>
                    )
                ) : null}
                {!isStatusClosed() && process.env.REACT_APP_FEATURE_CMISR3 === "true" ? (
                    <AdditionalActions
                        className={classes.workOrderAdditionalActions}
                        isAdmin={true}
                        onInComplete={() => setShowInCompleteModal(true)}
                        jobActions={false}
                        workOrder={workOrderData}
                    />
                ) : null}
                <div className={classes.tabContainer}>
                    <div>
                        <Tabs value={selectedTab} onChange={handleChange} aria-label="work order tabs" className={classes.notPrinted}>
                            <Tab label={intl.formatMessage(messages.workOrderInfoTabCaption)} />
                            <Tab label={intl.formatMessage(messages.costInfoTabCaption)} disabled={!enabledCostInformation} />
                            <Tab label={intl.formatMessage(messages.locateInfoTabCaption)} />
                        </Tabs>
                    </div>
                    <div>
                        {workOrderData?.relatedIdInformation?.relatedId && (
                            <span style={{ color: "#00549A", fontSize: "14px", lineHeight: "16px", cursor: "auto" }}>
                                {workOrderData?.relatedIdInformation?.relatedId}
                            </span>
                        )}
                    </div>
                </div>
            </div>
            <div className={classes.print}>
                <Button key="0" onClick={print} className={classes.notPrinted}>
                    <PrintIcon />
                    <FormattedMessage id="admin.work-order-details.print" defaultMessage="Print" description="Admin work order print button" />
                </Button>
            </div>
            <TabPanel value={selectedTab} index={0}>
                <WorkOrderInformation />
            </TabPanel>
            <TabPanel value={selectedTab} index={1}>
                <CostInformation
                    workorderData={workOrderData?.workorderData}
                    purchaseOrderNumber={purchaseOrderNumber}
                    relatedIdInformation={workOrderData?.relatedIdInformation}
                />
            </TabPanel>
            <TabPanel value={selectedTab} index={2}>
                <RelatedWork
                    workorderData={workOrderData?.workorderData}
                    triggerPopup={triggerPopup}
                    setTriggerPopup={setTriggerPopup}
                    relatedIdInformation={workOrderData?.relatedIdInformation}
                    relatedWOList={workOrderData?.realtedWOListData}
                    orderedRelatedWOData={workOrderData?.orderedRelatedWOData}
                />
            </TabPanel>
        </div>
    );
};

export default WorkOrderDetails;
